import { InteractionsTotalMetric } from "../charts-metrics/InteractionsTotalMetric";
import { LevelPieChart } from "../charts-metrics/LevelPieChart";
import { ShelterExitDayTypeMetric } from "../charts-metrics/ShelterExitDayTypeMetric";
import { InfractionsBarChart } from "../charts-metrics/InfractionsBarChart";
import { ShelterIntakeDayMetric } from "../charts-metrics/ShelterIntakeDayMetric";
import { ShelterOccupancyLineChart } from "../charts-metrics/ShelterOccupancyLineChart";
import { ShelterOccupancyPercentageMetric } from "../charts-metrics/ShelterOccupancyPercentageMetric";
import { ShelterOccupiedMetric } from "../charts-metrics/ShelterOccupiedMetric";
import { ShelterVacancyMetric } from "../charts-metrics/ShelterVacancyMetric";
import { GoalsCompletedMetric } from "../charts-metrics/GoalsCompletedMetric";
import { TasksCompletedMetric } from "../charts-metrics/TasksCompletedMetric";
import { InteractionsBarChart } from "../charts-metrics/InteractionsBarChart";
import { GoalsCompletedTable } from "../charts-metrics/GoalsCompletedTable";
import { TasksCompletedTable } from "../charts-metrics/TasksCompletedTable";
import { InteractionsTable } from "../charts-metrics/InteractionsTable";
import { JobsTable } from "../charts-metrics/JobsTable";
import { ProgramTable } from "../charts-metrics/ProgramTable";
import { ResourcesMetric } from "../charts-metrics/ResourcesMetric";
import { ResourcesAssignedByTypeTable } from "../charts-metrics/ResourcesAssignedByTypeTable";
import { GoalsOutstandingMetric } from "../charts-metrics/GoalsOutstandingMetric";
import { GoalsCompletedPercentageMetric } from "../charts-metrics/GoalsCompletedPercentageMetric";
import { GoalsOutstandingTable } from "../charts-metrics/GoalsOutstandingTable";
import { CasesCompletingGoalsTable } from "../charts-metrics/CasesCompletingGoalsTable";
import { InteractionsStaleTable } from "../charts-metrics/InteractionsStaleTable";
import { ShelterExitDayMetric } from "../charts-metrics/ShelterExitDayMetric";
import { ShelterExitTypePieChart } from "../charts-metrics/ShelterExitTypePieChart";
import { JobsStackedBarChart } from "../charts-metrics/JobsStackedBarChart";
import { ResourceAssignmentPieChart } from "../charts-metrics/ResourceAssignmentPieChart";
import { ResourcesAssignedTable } from "../charts-metrics/ResourcesAssignedTable";

export const dashboardMap: Record<
  string,
  { component: React.ComponentType<any>; defaultCols: string; maxCols: string; defaultProps?: object; useDateTimePicker?: boolean }
> = {
  //interactions
  interactions_all: {
    component: InteractionsTotalMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
  },
  interactions_by_type: {
    component: InteractionsTotalMetric,
    defaultCols: "3",
    maxCols: "4",
    defaultProps: { byType: true },
    useDateTimePicker: true,
  },
  interactions_bar_chart: {
    component: InteractionsBarChart,
    defaultCols: "6",
    maxCols: "9",
    useDateTimePicker: true,
  },
  interactions_table: {
    component: InteractionsTable,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
  },
  interactions_stale_table: {
    component: InteractionsStaleTable,
    defaultCols: "8",
    maxCols: "12",
  },
  //goals and tasks
  goals_outstanding: {
    component: GoalsOutstandingMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
  },
  goals_outstanding_table: {
    component: GoalsOutstandingTable,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
  },
  goals_completed: {
    component: GoalsCompletedMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
  },
  goals_completed_table: {
    component: GoalsCompletedTable,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
  },
  tasks_completed: {
    component: TasksCompletedMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
  },
  tasks_completed_table: {
    component: TasksCompletedTable,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
  },
  goals_completed_pct: {
    component: GoalsCompletedPercentageMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
  },
  cases_completing_goals_table: {
    component: CasesCompletingGoalsTable,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
  },
  infractions_bar_chart: {
    component: InfractionsBarChart,
    defaultCols: "6",
    maxCols: "9",
    useDateTimePicker: true,
  },
  //shelter
  shelter_7_day_exit: {
    component: ShelterExitDayMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
  },
  shelter_7_day_voluntary_exit: {
    component: ShelterExitDayTypeMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
    defaultProps: { exitType: "voluntary" },
  },
  shelter_7_day_involuntary_exit: {
    component: ShelterExitDayTypeMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
    defaultProps: { exitType: "involuntary" },
  },
  shelter_7_day_ban_exit: {
    component: ShelterExitDayTypeMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
    defaultProps: { exitType: "ban" },
  },
  shelter_7_day_intake: {
    component: ShelterIntakeDayMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
  },
  shelter_30_day_occupancy: {
    component: ShelterOccupancyLineChart,
    defaultCols: "6",
    maxCols: "9",
    useDateTimePicker: true,
  },
  shelter_occupancy_pct: {
    component: ShelterOccupancyPercentageMetric,
    defaultCols: "2",
    maxCols: "3",
  },
  shelter_occupied_beds: {
    component: ShelterOccupiedMetric,
    defaultCols: "2",
    maxCols: "3",
  },
  shelter_vacant_beds: {
    component: ShelterVacancyMetric,
    defaultCols: "2",
    maxCols: "3",
  },
  shelter_exit_type_pie_chart: {
    component: ShelterExitTypePieChart,
    defaultCols: "6",
    maxCols: "9",
    useDateTimePicker: true,
  },
  //programming
  program_level_pie_chart: {
    component: LevelPieChart,
    defaultCols: "6",
    maxCols: "9",
    defaultProps: { showHeader: true },
  },
  program_table: {
    component: ProgramTable,
    defaultCols: "8",
    maxCols: "12",
    defaultProps: { showHeader: true },
  },
  //job assignments
  job_table: {
    component: JobsTable,
    defaultCols: "8",
    maxCols: "12",
    defaultProps: { showHeader: true },
  },
  job_department_pie_chart: {
    component: JobsStackedBarChart,
    defaultCols: "8",
    maxCols: "12",
    defaultProps: { showHeader: true },
  },
  //resources
  people_assigned_resources: {
    component: ResourcesMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
    defaultProps: { metricType: "people" },
  },
  consumables_assigned: {
    component: ResourcesMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
    defaultProps: { metricType: "resources", resourceType: "consumable" },
  },
  nonconsumables_assigned: {
    component: ResourcesMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
    defaultProps: { metricType: "resources", resourceType: "nonconsumable" },
  },
  resource_usage_pct: {
    component: ResourcesMetric,
    defaultCols: "2",
    maxCols: "3",
    useDateTimePicker: true,
    defaultProps: { metricType: "usage" },
  },
  resource_assignment_pie_chart: {
    component: ResourceAssignmentPieChart,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
  },
  consumables_assigned_table: {
    component: ResourcesAssignedByTypeTable,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
    defaultProps: { resourceType: "consumable" },
  },
  nonconsumables_assigned_table: {
    component: ResourcesAssignedByTypeTable,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
    defaultProps: { resourceType: "nonconsumable" },
  },
  resources_assigned_table: {
    component: ResourcesAssignedTable,
    defaultCols: "8",
    maxCols: "12",
    useDateTimePicker: true,
  },
};
